"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var linkage_1 = require("../shared/linkage");
var shared_1 = require("@formily/shared");
exports.useValueStateLinkageEffect = function (scope) {
    return linkage_1.useValueLinkageEffect({
        type: 'value:state',
        resolve: function (_a, _b) {
            var target = _a.target, complie = _a.complie;
            var setFieldState = _b.setFieldState;
            setFieldState(target, function (innerState) {
                shared_1.merge(innerState, complie('state', {
                    $target: innerState
                }), {
                    assign: true,
                    arrayMerge: function (target, source) { return source; }
                });
            });
        },
        reject: function (_a, _b) {
            var target = _a.target, otherwise = _a.otherwise, complie = _a.complie;
            var setFieldState = _b.setFieldState;
            if (!otherwise)
                return;
            setFieldState(target, function (innerState) {
                shared_1.merge(innerState, complie('otherwise', {
                    $target: innerState
                }), {
                    assign: true,
                    arrayMerge: function (target, source) { return source; }
                });
            });
        },
        scope: scope
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/linkages/state.js
// module id = 5777
// module chunks = 0